export const GITHUB_TICKET_TYPE_TEXT = "GITHUB_ISSUES";